import { isWeb } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { useEffect, useState } from 'react';

import { PageContainer, ScreenTwoPageLayout } from '~/components/Page/Page.Container';
import type { ScreenPropPurchasesByEmail } from '~/navigation/Navigation.types';

import { PurchaseItemScreenComponent } from '../PurchaseItem';
import { PurchaseList, PurchaseListNative } from '../PurchasesByCustomerId/Purchase.List';

export const PurchasesByEmailScreen = (props: ScreenPropPurchasesByEmail) => {
  return (
    <PageContainer>
      <PurchasesLayout {...props} />
    </PageContainer>
  );
};

export const PurchasesLayout = (props: ScreenPropPurchasesByEmail) => {
  const purchaseId = props.route.params?.id;
  const email = props.route.params?.email;

  const [id, setId] = useState<string | undefined>(props.route.params?.id);

  useEffect(() => {
    setId(purchaseId);
  }, [purchaseId]);

  return (
    <ScreenTwoPageLayout>
      {isWeb ? (
        <PurchaseList onPress={(item) => setId(item.id)} email={email} />
      ) : (
        <PurchaseListNative email={email} />
      )}
      {id ? (
        <PurchaseItemScreenComponent purchaseId={id} onClose={() => setId(undefined)} />
      ) : (
        <></>
      )}
    </ScreenTwoPageLayout>
  );
};
